module.exports = {"220272001":"高新开发区街道","220272002":"新北街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220272.json
// module id = 623
// module chunks = 0